


import echarts from 'echarts'

export default{
    data() {
        return {
            
        }
    },
    mounted() {
        const me = this;
        me.initChart();
    },
    methods: {
        initChart(){
            const me = this, box = me.$refs['sh_bar_chart'];
            let charts = echarts.init(box);
            charts.setOption({
                color: ['#00897B', '#2196f3', '#3f51b5', '#7b4ffc', '#ff54a8', '#e53935',
                '#8e24aa', '#009688', '#22bb87', '#8bc34a', '#cddc39', '#ffeb3b',
                '#ffc107', '#ff9800', '#ff5722', '#651fff', '#7c4dff', '#aa00ff',
                '#d81b60', '#512da8', '#00ac95', '#00c853', '#009688', '#0274a9',
                '#34be7c', '#43a047'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    top:'4%',
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                },
                yAxis: {
                    type: 'category',
                    data: ['达州市', '攀枝花市', '甘孜州', '雅安市', '泸州市', '绵阳市', '巴中市', '眉山市', '乐山市', '成都市']
                },
                series: [{
                    name: '项目数量',
                    type: 'bar',
                    data: [70, 89, 99, 123, 135, 156, 175, 187, 189, 233],
                    label: {
                        show: true, //开启显示
                        position:'insideRight',
                        
                    }
                }]
            });
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/base/view/cmps/charts/bar/src/bar.js